// extracted by mini-css-extract-plugin
export default {"alertBox":"resend-verification-messages_alertBox__6ugDs"};